import { render, staticRenderFns } from "./ShortProtocolList.vue?vue&type=template&id=81066ad8&scoped=true"
import script from "./ShortProtocolList.vue?vue&type=script&lang=js"
export * from "./ShortProtocolList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81066ad8",
  null
  
)

export default component.exports